// eslint-disable-next-line import/prefer-default-export
export const GLOBAL_LOADER_SET = 'GLOBAL_LOADER_SET';
